import { render, staticRenderFns } from "./Outlets.vue?vue&type=template&id=3f807c86&scoped=true&"
import script from "./Outlets.vue?vue&type=script&lang=js&"
export * from "./Outlets.vue?vue&type=script&lang=js&"
import style0 from "./Outlets.vue?vue&type=style&index=0&id=3f807c86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f807c86",
  null
  
)

export default component.exports